export const PAGE_KEY = 'learning-collaborator-diplomas';
